import './index.scss';
import pic from './imgs/1.jpeg';

const AboutUs = () => {
  return (

    <div className="about-us">
      <div className='main-content'>
        <div className='about-us_flex'>
          <div className='about-us_title'>
            <div className='about-us_title-p1'>ABOUT</div>
            <div className='about-us_title-p2'>关于我们</div>
            <div className='about-us_title-p3'>INTRODUCE</div>
          </div>
          <div className='about-us_pic'></div>
        </div>
        <div className='about-us_info'>
          上海迷果科技拥有3D艺术的技术工坊，主要为多媒体及游戏行业 <br></br>
          提供潮流的人物设计，角色设计，场景设计等多样优质美术制作，为您的产品赋予新生。<br></br>
          我们缔造了合作的新标准；为国内外知名厂商提供了大量制作资源。<br></br>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
